const permissions = {
  viewOrders: 'OR001',
  addOrders: 'OR002',
  editOrders: 'OR003',
  deleteOrders: 'OR004',
  optimizeOrders: 'OR005'
};

export default permissions;
